import { multiFilter } from "@homebound/beam";
import { useMemo } from "react";
import { ReadyPlanStatus } from "src/generated/graphqlTypes";
import { useReadyPlanStatusFilterMetadataQuery } from "src/hooks/filters/readyPlanStatus/useReadyPlanStatusFilter.generated";

type UseReadyPlanStatusFilterOptions = {
  // DesignPackage entities are only ever Active or Archived; unlike PlanPackages they don't
  // use the Draft entity status (draft work is tracked at the version level via
  // AggregateVersionStatus). So this flag drops Draft from the filter options — it would never
  // match anything — and defaults the filter to Active.
  isDPFilter?: boolean;
};

export function useReadyPlanStatusFilter(opts: UseReadyPlanStatusFilterOptions = {}) {
  const { isDPFilter } = opts;
  const { data } = useReadyPlanStatusFilterMetadataQuery({ fetchPolicy: "cache-first" });
  const rpStatusFilter = useMemo(
    () =>
      multiFilter({
        options: (data?.enumDetails.readyPlanStatus ?? []).filter(
          (s) => !isDPFilter || s.code !== ReadyPlanStatus.Draft,
        ),
        getOptionValue: (o) => o.code,
        getOptionLabel: (o) => o.name,
        // Default to Active so the filter UI matches what the list query actually returns
        defaultValue: isDPFilter ? [ReadyPlanStatus.Active] : undefined,
      }),
    [data, isDPFilter],
  );

  return { rpStatusFilter };
}
